/* eslint-disable no-redeclare */
import { useCallback, useContext } from 'react';
import { Center, Image, Space } from '@mantine/core';
import SkeletonItems from '../../Atoms/SkeletonItems';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import EmailHistoryListItem from './EmailHistoryListItem';

const EmailHistoryList = () => {
  const { messages, loading, selectedMessage, selectMessage } = useContext(EmailBoxContext);

  const isActive = useCallback(
    (emailId) => selectedMessage && (selectedMessage.id === emailId || selectedMessage.stringId === emailId),
    [selectedMessage],
  );

  if (loading) {
    return (
      <div style={{ padding: 10 }}>
        <SkeletonItems count={8} height={80} />
      </div>
    );
  }

  if (messages.length === 0) {
    return (
      <Center mt="10rem">
        <Image width={192} src="/img/redpanda-inbox.svg" caption="Keine E-Mails" />
      </Center>
    );
  }

  return (
    <>
      <Space h="xs" />
      {messages.map((email) => (
        <div key={email.id ?? email.stringId}>
          <EmailHistoryListItem
            active={isActive(email.id ?? email.stringId)}
            onClick={() => selectMessage(email)}
            email={email}
          />
        </div>
      ))}
    </>
  );
};

export default EmailHistoryList;
